exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-521baa03] .w-e-modal {\n  position: relative;\n  z-index: 9999;\n}\n[data-v-521baa03] .w-e-modal button {\n  line-height: 10px !important;\n}\n", ""]);

// exports
